export default __webpack_public_path__ + "static/media/suu.f250894f.svg";